import http from './http'
const base = '/Telas/Mensageria'
export default {
  async getSummary () { return (await http.get(`${base}/GetSummary`)).data },
  async getPaged (params) { return (await http.get(`${base}/GetPaged`, { params })).data },
  async getById (direction, id) { return (await http.get(`${base}/GetById/${direction}/${id}`)).data },
  async receive (input) { return (await http.post(`${base}/Receive`, input)).data },
  async reprocess (direction, id, reason) { await http.post(`${base}/Reprocess/${direction}/${id}`, { reason }) },
  async ignore (direction, id, reason) { await http.post(`${base}/Ignore/${direction}/${id}`, { reason }) }
}
